const url = typeof window !== 'undefined' ? window?.location?.href : '';
const isDraftProduct = Boolean(url.match(/\?draftProductId=([0-9]+)\&?/i))

export default isDraftProduct;
